"use strict";

require("phoenix_html");

var _jquery = require("jquery");

var _jquery2 = _interopRequireDefault(_jquery);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

(0, _jquery2.default)(function () {
  (0, _jquery2.default)('.tap-open-image').on('click', function (e) {
    var img = e.currentTarget.getAttribute('open_url');

    // set and open viwer
    (0, _jquery2.default)('.image-view-wrapper').addClass('show');
    (0, _jquery2.default)('.image-view-wrapper > img')[0].setAttribute('src', img);
  });

  (0, _jquery2.default)('.image-view-wrapper a i').on('click', function () {
    (0, _jquery2.default)('.image-view-wrapper').removeClass('show');
  });

  // close alert
  (0, _jquery2.default)('.alert-wrapper a.close').on('click', function (e) {
    (0, _jquery2.default)(e.target).parents('.alert-wrapper').hide();
  });

  (0, _jquery2.default)('.open-dynamic-alert').on('click', function (e) {
    var el = (0, _jquery2.default)(e.currentTarget);
    var title = el.attr('alert-title'),
        msg = el.attr('alert-msg'),
        submitLink = el.attr('alert-submit-link'),
        submitText = el.attr('alert-submit-text'),
        textStyle = el.attr('alert-text-style');

    var alertEl = (0, _jquery2.default)('.dynamic-alert')[0];

    (0, _jquery2.default)(alertEl).css({ display: 'flex' });
    (0, _jquery2.default)(alertEl).find('h3')[0].innerHTML = title;
    (0, _jquery2.default)(alertEl).find('p')[0].innerHTML = msg;
    (0, _jquery2.default)(alertEl).find('a:last-child')[0].innerHTML = submitText;
    (0, _jquery2.default)(alertEl).find('a:last-child')[0].setAttribute('href', submitLink);
    (0, _jquery2.default)(alertEl).find('p')[0].style = textStyle;
  });

  (0, _jquery2.default)('#join-form > form').submit(function () {
    (0, _jquery2.default)('.loading-filter').addClass('loading');
  });
});
